import {
  type CapturePulseBlockMutation,
  type CapturePulseBlockMutationVariables,
  type CapturePulseTableBlockMutation,
  type CapturePulseTableBlockMutationVariables,
  useCapturePulseBlockMutation,
  useCapturePulseTableBlockMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

type CapturePulseBlockResponse = Extract<
  NonNullable<CapturePulseBlockMutation['capturePulseBlock']>,
  { __typename: 'PulseV1CapturePulseBlockResponse' }
>;

export const useCapturePulseBlock = withStandardMutationHook<
  CapturePulseBlockMutation,
  CapturePulseBlockResponse,
  CapturePulseBlockMutationVariables,
  'capturePulseBlock'
>(useCapturePulseBlockMutation, 'capturePulseBlock', undefined, {
  refetchQueries: ['Pulse'],
  awaitRefetchQueries: true,
});

export const useCapturePulseTableBlock = withStandardMutationHook<
  CapturePulseTableBlockMutation,
  CapturePulseBlockResponse,
  CapturePulseTableBlockMutationVariables,
  'capturePulseBlock'
>(useCapturePulseTableBlockMutation, 'capturePulseBlock', undefined, {
  refetchQueries: ['Pulse'],
  awaitRefetchQueries: true,
});
